import { TranslatableText } from '@dreryk/react-common';
import { Loader, LoaderSize, SecondaryText } from '@dreryk/react-components';

import { StyledPasswordSettingsLoader } from './StyledPasswordSettingsLoader';

type PasswordSettingsLoaderProps = {
   readonly text?: TranslatableText;
};

const PasswordSettingsLoader = (props: PasswordSettingsLoaderProps): JSX.Element => {
   return (
      <StyledPasswordSettingsLoader>
         <Loader size={LoaderSize.SMALL} testId={'loader'} />
         {props.text ? <SecondaryText text={props.text} testId={'passwordSettings'} /> : null}
      </StyledPasswordSettingsLoader>
   );
};

export { PasswordSettingsLoader };
